import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConfigProvider } from '@dexma/ui-components';
import styled, { StyleSheetManager } from 'styled-components';
import { BrowserRouter as Router } from 'react-router-dom';
import crossFetch from 'cross-fetch';
import { datadogLogs } from '@datadog/browser-logs';
import { initReactI18next } from 'react-i18next';

import getDataDogConfig from 'adapter/in/dashboards/config/datadog';
import { log } from 'adapter/in/common/config/pino';

import i18n from 'asset/translation';

import httpClient from 'adapter/in/common/utils/httpClient';
import App from 'adapter/in/dashboards/app';

import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';

// TODO check better approach for different ports in local (json-server) than in pre/prod
if (!process.env.ENV) {
    throw new Error();
}

let port: number;
let apiPrefix: string;
let pathUrl: string;

if (process.env.ENV === 'DEVELOPMENT') {
    port = 4000;
    apiPrefix = '';
    pathUrl = '';
} else {
    port = 80;
    apiPrefix = '/api-v3';
    pathUrl = 'dashboardsv2/';
    datadogLogs.init(getDataDogConfig());
}

i18n.use(initReactI18next);
log.info(`Welcome to ${process.env.NAME} ${VERSION}`);

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

const fetch = httpClient(crossFetch, window.location.search);

const host = document.querySelector<HTMLElement>('#dashboards') as HTMLElement;

const styleSlot = host.querySelector('#dashboards-root') as HTMLElement;
const renderIn = host.querySelector('#dashboards-slot') as HTMLElement;

const StyledApp = styled.div`
    height: 100%;

    & > div:first-child {
        height: 100%;
    }
`;

createRoot(renderIn).render(
    <>
        <StyleSheetManager target={styleSlot}>
            <StyledApp>
                <ConfigProvider getPopupContainer={() => styleSlot}>
                    <Router basename='/'>
                        <App port={port} apiPrefix={apiPrefix} pathUrl={pathUrl} fetch={fetch} />
                    </Router>
                </ConfigProvider>
            </StyledApp>
        </StyleSheetManager>
    </>
);
